import { psikolojikSaglamlikQuestions } from '../data/forms';

export const calculatePsikolojikSaglamlik = (answers) => {
  let totalScore = 0;
  let risks = [];

  Object.entries(answers).forEach(([questionId, answerValue]) => {
    const numId = Number(questionId);
    const numericAnswer = Number(answerValue); // 1 ile 5 arası gelen cevap

    // Soruyu veritabanından bul
    const question = psikolojikSaglamlikQuestions.find(q => q.id === numId);
    const actualText = question ? question.text : `Soru ${questionId}`;

    // KLİNİK MÜDAHALE: Ters Kodlama Mantığı
    // Eğer form.js'de reverse: true dediysek, puanı tersine çeviriyoruz (6 - x)
    let finalScore = numericAnswer;
    if (question && question.reverse) {
      finalScore = 6 - numericAnswer;
    }

    totalScore += finalScore;

    // Risk Tespiti: Nihai toparlanma puanı 2 veya altındaysa (Yani çocuk zor toparlanıyorsa) bunu riske at
    if (finalScore <= 2) {
      risks.push({
        id: questionId,
        text: actualText,
        score: finalScore,
        isCritical: finalScore === 1 // Kesinlikle toparlanamıyorum dediyse kritik kırmızı alarm
      });
    }
  });

  // Klinik Değerlendirme Çıktısı (Min: 6, Maks: 30)
  let summaryText = "Normal Düzey Psikolojik Sağlamlık";
  if (totalScore < 18) {
    summaryText = "Düşük Psikolojik Sağlamlık (Risk Kategorisi)";
  } else if (totalScore >= 25) {
    summaryText = "Yüksek Psikolojik Sağlamlık";
  }

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Sağlamlık testi olduğu için: Düşük Puan = Yüksek Risk
  // 6 (En Düşük Sağlamlık) -> 100 Risk Skoru
  // 30 (En Yüksek Sağlamlık) -> 0 Risk Skoru
  const normalizedRiskScore = Math.round(100 - (((totalScore - 6) / 24) * 100));
  
  const masterRisk = totalScore < 18 ? "high" : (totalScore >= 25 ? "low" : "medium");
  const hasCriticalItem = risks.some(r => r.isCritical);

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: normalizedRiskScore,
    masterRisk: masterRisk,
    isCritical: hasCriticalItem, // Herhangi bir maddede 'Asla toparlanamam' dediyse kritik işaretle
    domain: "psychological",

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
    totalScore, 
    risks, 
    summary: summaryText,
    riskLevel: masterRisk
  };
};